// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import ManagementRoleType from '../contract/ManagementRoleType';

export default function managementRoleType(data: ManagementRoleType): ManagementRoleType {
    let result: ManagementRoleType = {
        __type: 'ManagementRoleType:#Exchange',
        ...data,
    };

    return result;
}
